import { render, staticRenderFns } from "./listadoLibrosBodega.vue?vue&type=template&id=222880be"
import script from "./listadoLibrosBodega.vue?vue&type=script&lang=js"
export * from "./listadoLibrosBodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports